<template>
  <div class="wrapper">
    <div class="tf__init--popup" v-if="profile && profile.banner && showBanner && profile.role.name == 'guest'">
      <div class="tf__in-pu--box">
        <button class="btn btn-close" @click="onCloseBannerClicked">
          <i class="fas fa-times"></i>
        </button>
        <p>
          {{profile.banner && profile.banner.banner_text}}
        </p>
      </div>
    </div>
    <notifications/>
    <div class="main-content">
      <ProjectNavBar 
        @calendarClicked="handleCalendarClicked()"
        @userClicked="handleUserClicked()" 
        @headerLoginClicked="onHeaderLoginClicked"
        @detailClicked="handleDetailClicked()" />
      <router-view
         v-if="profile"
         @assignedByUserClicked="handleAssignedByUserClicked"
         @assignedToUserClicked="handleAssignedToUserClicked"
         @financeClicked="_onFinanceClicked"  
         @taskDblClick="handleTaskDblClick"  
         @loginClicked="handleLoginClick" 
         :taskCreateFlag="taskCreateFlag" 
         :taskLoadingFlag="taskLoadingFlag"/>
      <SidebarRight
        @overlayClicked="outside"
        v-click-outside="outside"
        :class="['navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400', {'open': showSideBar, 'offcanvas-collapse--80p offcanvas-collapse--chat': fullWidth}]">
        <component 
          :is="currentView" 
          :editId="editId"
          :data="data"
          @closeClick="outside"
          @iAmNewClicked="handleIAmNewClicked"
          @backClickedFromRegister="currentView='Login'"
          @backClickedFromForgot="currentView='Login'"
          @forgotPasswordLinkClicked="currentView='Forgot'"
          @registerSuccess="onRegisterSuccess"
          @resetPasswordSuccess="onResetPasswordSuccess"
          @userVerified="onUserVerificationSuccess"
          @taskCreated="onTaskCreated"
          @taskDeleted="outside"
          />
      </SidebarRight>
      <!-- <content-footer></content-footer> -->
      
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import TasksHome from '@/app/pages/TasksHome.vue'


import ProjectNavBar from './ProjectNavBar.vue';
import ContentFooter from './Footer.vue';
import SidebarRight from './SidebarRight'
import { FadeTransition } from 'vue2-transitions';

//sidebar components
import Another from '@/app/components/Another.vue'
import Preference from '@/app/components/Preference.vue'
import CreateAssetTask from '@/app/components/CreateAssetTask.vue'
import AssetThread from '@/app/components/AssetThread.vue'
import DetailLog from '@/app/components/DetailLog.vue'
import Finance from '@/app/components/Finance.vue'
import { mapActions, mapState, mapMutations } from 'vuex';

import Login from '@/app/components/Login.vue'
import Register from '@/app/components/Register.vue'
import Verify from '@/app/components/Verify.vue'
import Forgot from '@/app/components/Forgot.vue'
import ChangeTaskOwner from "@/app/components/ChangeTaskOwner.vue";
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    ProjectNavBar,
    ContentFooter,
    FadeTransition,
    SidebarRight,
    TasksHome,
    Another,
    CreateAssetTask,
    AssetThread,
    Preference,
    DetailLog,
     Login,
    Register,
    Verify,
    Forgot,
    Finance,
    ChangeTaskOwner
  },
  data() {
    return {
       showSideBar: false,
       currentView: 'Another',
       taskCreateFlag: false,
       editId: null,
       fullWidth: false,
       data: null,
       taskLoadingFlag: true,
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      console.log("hi before ", to)
      if (!vm.$auth.isAuthenticated()) {
         let email = "demo@andmine.com";
         await vm.initLogin(email);
         await vm.fetchUserInfoAction();
         next()
       
      } else {
        await vm.fetchUserInfoAction()
        console.log(to.name == "projects" , to.query.success == "true", "ha ha this is to")
        if(to.name == "projects" && to.query.success == "true") {
          const approvalTasksStr = localStorage.getItem("approvalTasks");
          //console.log(approvalTasks, "approvaltasks")
          if(approvalTasksStr) {
            const approvalTasks = JSON.parse(approvalTasksStr)
            if(approvalTasks.length > 0) {
              const parentId = approvalTasks[0].parent_id;
              next('/projects/'+parentId+'/?success=true')
            } else {
              next('/')
            }
            
          }
        } else if(to.name == "projects" && to.query.return == "true") { 
          const stripeConnectProjectId = localStorage.getItem("stripe_connect_project");
          //console.log(approvalTasks, "approvaltasks")
          if(stripeConnectProjectId) {
            next('/projects/'+stripeConnectProjectId+'/?return=true')
          }
        }
      }

      await vm.postLoginCheck()
    });
  },

  computed: {
    ...mapState('task', ['singleTask']),
    ...mapState('user',['profile']),
    ...mapState(["showBanner"]),
  },

  async created() {
    //await this.startLogin()
  },

  

  mounted () {
    if(this.$route.query.login) {
            this.currentView = "Login";
            this.showSideBar = true;
          }
    this.$nextTick(async () => {
      let showBanner = sessionStorage.getItem("banner_shown")
      if(showBanner != 'true') {
        this.setShowBanner(true)
      } else {
        this.setShowBanner(false)
      }
      
    })
    
  },

  

  methods: {
    ...mapActions('user',['fetchUserInfoAction']),
    ...mapActions('task',['fetchSingleTask']),
    ...mapMutations(["setShowBanner","setLoading"]),

    initLogin(username) {
      const clientId = process.env.VUE_APP_CLIENT_ID;
      const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
      this.setLoading(true);
      return this.$auth
        .login({
          username: username,
          password: "secret",
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: "password"
        })
        .then(r => {
          this.setLoading(false);
          return Promise.resolve(true);
        })
        .catch(e => {
          this.setLoading(false);
          this.$snack.success("Invalid Credentials.");
          return Promise.reject(false);
        });
    },

    async postLoginCheck() {
     
     if (this.profile.role.name == "invite") {
      // console.log(this.profile, 'roooooooo')
       //logout last invite login and relogin demo
      await this.initLogin(this.profile.email);
      await this.fetchUserInfoAction();
     }

     //if invition
     if (this.$route.query.login && this.$route.query.token && !this.$auth.isAuthenticated()) {
       try {

         let r = await this.fetchInvitation(this.$route.query.token);
         console.log(r, "aaaa");
         if (r.data) {
           this.invitation = r.data;
           email = this.invitation.invitedTo && this.invitation.invitedTo.email;
           let role = this.invitation.invitedTo.role;
           //console.log("roleid", role)
           if (role.name == "invite") {
             await this.initLogin(email);
             await this.fetchUserInfoAction();
             this.$router.replace({
               name: "invite",
               params: { invitation: this.invitation }
               //query: this.$route.query
             });
             return false;
           } else {
             //if not logged in already then show login form
             if (this.profile.role.name == "guest") {
               this.authenticated = true;
               this.currentView = "Login";
               this.showSideBar = true;
             } else {
               // now user is already logged
               //check if invition is for him
               if (this.invitation) {
                 let currentUserEmail = this.profile.email;
                 if (currentUserEmail != email) {
                   this.$notify({
                     type: "success",
                     message:
                       "You are logged in with different account. Please logout and sign in with correct details."
                   });
                   this.$snack.success(
                     "You are logged in with different account. Please logout and sign in with correct details."
                   );
                   return false;
                 } else {
                   //send him direct to related task
                   let { id, name } = this.invitation.parent
                     ? this.invitation.parent
                     : this.invitation.project;
                   this.$router.push({
                     name: "tasks.quote",
                     params: {
                       id: id,
                       name: name,
                       showThread: this.invitation.parent ? true : false,
                       threadId: this.invitation.project.id,
                       screen: this.invitation.invitation_type
                     }
                   });
                 }
               }
             }
           }
         } else {
           
           this.$snack.success("Invalid Link");

           return false;
         }
       } catch (e) {
         //console.log(e)
       }
     } 
   
 },

    _onFinanceClicked(project_id, event) {
      this.currentView = "Finance"
      this.showSideBar = true
      this.fullWidth = true
    },
    handleTaskDblClick (data, event) {
      console.log(data)
      if(this.profile.role.name != "guest") {
        if(data.id) {
          if(data.id == "assigned-tasks" || data.id == "assigned-by") {
            this.$snack.success("Can not create tasks for view only project.");
          } else {
            
            this.currentView = "AssetThread"
            this.showSideBar = true
            this.fullWidth = true
            this.data = data
            this.editId = data.id;
          }
          
        }
        else {
          this.data = data
          this.currentView = "AssetThread"
          this.showSideBar = true
          this.fullWidth = true
          this.editId = data.id;

        } 
      } else {
        //  this.currentView = "Login"
        //  this.showSideBar = true

        this.data = data
          this.currentView = "AssetThread"
          this.showSideBar = true
          this.fullWidth = true
          this.editId = data.id;
      }
     
    },
    onCloseBannerClicked() {
      this.setShowBanner(false)
      sessionStorage.setItem("banner_shown", true)
    },
    handleUserClicked () {
      this.currentView = "Preference"
      this.showSideBar = true

    },
     handleDetailClicked () {
      this.currentView = "DetailLog"
      this.showSideBar = true
    },

    handleCalendarClicked() {
      //alert("hi")
    },

    handleAssignedByUserClicked(id, userId, task) {
      if (this.profile.role.name != "guest") {
        //console.log(id)
        this.editId = id;
        this.currentView = "ChangeTaskOwner";
        this.showSideBar = true;
      } else {
        this.currentView = "Login";
        this.showSideBar = true;
      }
    },

    handleAssignedToUserClicked(id, userId, task) {
      if (this.profile.role.name != "guest") {
        //console.log(id)
        this.editId = id;
        this.currentView = "ChangeTaskOwner";
        this.showSideBar = true;
      } else {
        this.currentView = "Login";
        this.showSideBar = true;
      }
    },

    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    },
    handleDblClick() {
      this.currentView = "Another"
      this.showSideBar = true;    
      //this.$router.push('/home');
    },

    onTaskCreated (id, refresh=true) {
      //alert(id)
      //this.showSideBar = false;    
      this.taskCreateFlag = !this.taskCreateFlag;
      this.taskLoadingFlag = refresh;
      this.editId = ''+id
      //this.outside()
      //this.showSideBar = false
      
    },

    //login related
    handleLoginClick() {
      this.currentView = "Login"
      this.showSideBar = true;    
      //this.$router.push('/home');
    },

    onHeaderLoginClicked () {
      this.currentView = "Login"
      this.showSideBar = true;   
    },

    handleIAmNewClicked() {
      this.currentView = "Register"
      this.showSideBar = true;    
      //this.$router.push('/home');
    },

    onRegisterSuccess (data) {
      this.currentView = "Verify"
    },

    onResetPasswordSuccess () {
      this.$snack.success('Password has been reset successfully, please login.')
      this.currentView = "Login"
    },

    onUserVerificationSuccess () {
      this.$snack.success('Account has been verified successfully, please login.')
      this.currentView = "Login"
    },
    //end of login related

    outside() {
      if(this.showSideBar == true) {
        this.showSideBar = false;
        this.fullWidth = false
      }
        
    }
  }
};
</script>
